import { TeflStayHistoryInfo } from '../../lib/types/models/tefl/tefl'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTeflHistoryInfo(olId: number, teflId: number) {
  return restApiClient
    .url(constructApiUrl(API.tefl.getHistoryInfo.url, { olId, teflId }))
    .get<TeflStayHistoryInfo>()
}
